import { Badge } from 'react-bootstrap';
import '../../assets/css/common/required-badge.css';
import { useTranslation } from 'react-i18next';

export const RequiredBadge = () => {
    const { t } = useTranslation();
    return (
        <Badge bg="" className="required-badge">
            {t('badge.required')}
        </Badge>
    );
};

export const EitherOneRequiredBadge = () => {
    const { t } = useTranslation();
    return <span className="either-one-required-badge mb-2">{t('badge.either_one_required.badge')}</span>;
};

export const EitherOneRequiredText = () => {
    const { t } = useTranslation();
    return <span className="either-one-required-text">{t('badge.either_one_required.text')}</span>;
};
